<template>
  <div
    class="p-2 bg-white rounded-md !shadow-lg cursor-pointer"
    :class="{
      'ring-2 ring-gray-900': selected,
    }"
    @click="clickEvent"
  >
    <div class="flex gap-6 flex-col" @click="onClickSelected">
      <div class="bg-gray-100 rounded-md p-2">
        <div class="flex flex-row gap-4">
          <ol class="ml-2 mb-1 mt-2 space-y-2">
            <li class="flex items-center gap-2">
              <div class="uppercase text-gray-500 text-sm font-bold">
                Name:
              </div>
              <div class="text-sm overflow-visible">
                {{ item.name }}
              </div>
            </li>
            <li class="flex items-center gap-2">
              <div class="uppercase text-gray-500 text-sm font-bold">
                Address:
              </div>
              <div class="flex flex-row gap-4"
                v-if="item.address">
                <div class="text-sm overflow-visible">
                  {{ item.address.street }},
                </div>
                <div class="text-sm overflow-visible"
                  v-if="item.address.apartment">
                  {{ item.address.apartment }},
                </div>
                <div class="text-sm overflow-visible"
                  v-if="item.address.city">
                  {{ item.address.city }},
                </div>
                <div class="text-sm overflow-visible"
                  v-if="item.address.state">
                  {{ item.address.state }}
                </div>
                <div class="text-sm overflow-visible"
                  v-if="item.address.zip_code">
                  {{ item.address.zip_code }}
                </div>
              </div>
              <div class="text-sm text-gray-300"
                v-else>
                N/A
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: Object,
    selected: Boolean,
  },
  methods: {
    clickEvent() {
      // add other pure events on the building item here
    },
    onClickSelected() {
      this.$emit('changeSelected', this.item.id)
    },
  },
}
</script>

<style></style>
